/* eslint-disable complexity */
/* eslint-disable react/jsx-key */
import AddLocationAltOutlined from '@mui/icons-material/AddLocationAltOutlined';
import AddOutlined from '@mui/icons-material/AddOutlined';
import BallotIcon from '@mui/icons-material/Ballot';
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import EditLocationAltOutlined from '@mui/icons-material/EditLocationAltOutlined';
import EditOutlined from '@mui/icons-material/EditOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import NotListedLocationOutlined from '@mui/icons-material/NotListedLocationOutlined';
import PrintIcon from '@mui/icons-material/Print';
import WrongLocationOutlined from '@mui/icons-material/WrongLocationOutlined';
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import SortableTree from '@nosferatu500/react-sortable-tree';
import { isNull } from 'lodash';
import React, { useState } from 'react';
import { DndContext } from 'react-dnd';

import classes from './treeDataBodyWrapper.module.scss';

const TreeDataBodyWrapper = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowInfo, setSelectedRowInfo] = useState(null);

  const openMenu = Boolean(anchorEl);

  const handleClickMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowInfo(row);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowInfo(null);
  };

  return (
    <div className={classes.treeDataWrapper} style={{ height: 500 }}>
      <DndContext.Consumer>
        {({ dragDropManager }) => (
          <SortableTree
            dragDropManager={dragDropManager}
            className={classes.scrolableTreeBody}
            treeData={props.treeData}
            rowDirection="rtl"
            isVirtualized={false}
            canDrag={false}
            canDrop={false}
            onChange={props.changeHandler}
            onMoveNode={({ node, treeIndex, path }) =>
              global.console.debug(
                'node:',
                node,
                'treeIndex:',
                treeIndex,
                'path:',
                path,
              )
            }
            maxDepth={5}
            searchQuery={props.searchString}
            searchFocusOffset={props.searchFocusIndex}
            searchFinishCallback={matches => props.searchFinish(matches)}
            generateNodeProps={rowInfo => ({
              buttons: [
                rowInfo.node.type !== 'Cell' &&
                !isNull(rowInfo.node.childType) &&
                !rowInfo.node.addressGuid?.length ? (
                  <Tooltip placement="right" title="افزودن">
                    <div>
                      <IconButton
                        color="success"
                        onClick={() => props.createHandler(rowInfo)}
                      >
                        <AddOutlined />
                      </IconButton>
                    </div>
                  </Tooltip>
                ) : null,
                rowInfo.node.isComposable ? (
                  <Tooltip placement="right" title="ایجاد آدرس">
                    <div>
                      <IconButton
                        color="success"
                        onClick={() => props.composeHandler(rowInfo)}
                      >
                        <AddLocationAltOutlined />
                      </IconButton>
                    </div>
                  </Tooltip>
                ) : null,
                rowInfo.node.addressGuid?.length ? (
                  <Tooltip placement="right" title="پرینت">
                    <div>
                      <IconButton
                        color="info"
                        onClick={() => props.printHandler(rowInfo)}
                      >
                        <PrintIcon />
                      </IconButton>
                    </div>
                  </Tooltip>
                ) : null,
                !rowInfo.node.addressGuid?.length && rowInfo.node.hasPrints ? (
                  <Tooltip placement="right" title="پرینت جمعی">
                    <div>
                      <IconButton
                        color="info"
                        onClick={() => props.printHandler(rowInfo)}
                      >
                        <BallotIcon />
                      </IconButton>
                    </div>
                  </Tooltip>
                ) : null,

                <div>
                  <IconButton
                    id={`${rowInfo.node.guid}-button`}
                    aria-controls={
                      openMenu ? `${rowInfo.node.guid}-menu` : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={openMenu ? 'true' : undefined}
                    onClick={e => handleClickMenu(e, rowInfo)}
                  >
                    <MenuIcon />
                  </IconButton>
                </div>,
              ],
            })}
          />
        )}
      </DndContext.Consumer>

      <Menu
        id={`${selectedRowInfo?.node?.guid}-menu`}
        aria-labelledby={`${selectedRowInfo?.node?.guid}-button`}
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
      >
        {selectedRowInfo?.node?.addressGuid?.length ? (
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              props.showAddressHandler(selectedRowInfo);
            }}
          >
            <Action>
              <Typography fontSize={14}>نمایش آدرس</Typography>
              <NotListedLocationOutlined
                // sx={{ transform: 'rotate(180deg)' }}
                fontSize="small"
                color="info"
              />
            </Action>
          </MenuItem>
        ) : null}
        {selectedRowInfo?.node?.addressGuid?.length ? (
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              props.reComposeHandler(selectedRowInfo);
            }}
          >
            <Action>
              <Typography fontSize={14}>ویرایش آدرس</Typography>
              <EditLocationAltOutlined fontSize="small" color="warning" />
            </Action>
          </MenuItem>
        ) : null}
        {!selectedRowInfo?.node?.isComposable &&
        selectedRowInfo?.node?.addressGuid?.length ? (
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              props.deComposeHandler(selectedRowInfo);
            }}
          >
            <Action>
              <Typography fontSize={14}>حذف آدرس</Typography>
              <WrongLocationOutlined fontSize="small" color="error" />
            </Action>
          </MenuItem>
        ) : null}

        <MenuItem
          onClick={() => {
            props.editHandler(selectedRowInfo);
            handleCloseMenu();
          }}
        >
          <Action>
            <Typography fontSize={14}>ویرایش</Typography>
            <EditOutlined fontSize="small" color="warning" />
          </Action>
        </MenuItem>
        {!selectedRowInfo?.node?.addressGuid?.length &&
        selectedRowInfo?.node?.isDeletable ? (
          <MenuItem
            onClick={() => {
              props.deleteHandler(selectedRowInfo);
              handleCloseMenu();
            }}
          >
            <Action>
              <Typography fontSize={14}>حذف</Typography>
              <DeleteOutlineOutlined fontSize="small" color="error" />
            </Action>
          </MenuItem>
        ) : null}
      </Menu>
    </div>
  );
};

export default TreeDataBodyWrapper;

const Action = styled(Box)({
  paddingTop: '0.3rem',
  paddingBottom: '0.3rem',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.5rem',
});
